module.exports = __webpack_public_path__ + "respect.2eiCwqU5.svg";